import Vue from 'vue';
import App from './App.vue';
import router from './router';

// Import only the Element UI components actually used (instead of entire library)
import {
  Button,
  Input,
  Dialog,
  Image,
  Row,
  Col,
  Card,
  Header,
  Main,
  Container,
  Result,
  Avatar,
  Collapse,
  CollapseItem,
  Loading
} from 'element-ui';
import 'element-ui/lib/theme-chalk/base.css';
import 'element-ui/lib/theme-chalk/button.css';
import 'element-ui/lib/theme-chalk/input.css';
import 'element-ui/lib/theme-chalk/dialog.css';
import 'element-ui/lib/theme-chalk/image.css';
import 'element-ui/lib/theme-chalk/row.css';
import 'element-ui/lib/theme-chalk/col.css';
import 'element-ui/lib/theme-chalk/card.css';
import 'element-ui/lib/theme-chalk/header.css';
import 'element-ui/lib/theme-chalk/main.css';
import 'element-ui/lib/theme-chalk/container.css';
import 'element-ui/lib/theme-chalk/result.css';
import 'element-ui/lib/theme-chalk/avatar.css';
import 'element-ui/lib/theme-chalk/collapse.css';
import 'element-ui/lib/theme-chalk/collapse-item.css';
import 'element-ui/lib/theme-chalk/loading.css';
import 'element-ui/lib/theme-chalk/icon.css';

import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';

// Import Font Awesome (removed duplicate CDN link from index.html)
// Webfont CSS powers the <i class="fa..."> icons used across the pages (e.g. calendar before event date)
import '@fortawesome/fontawesome-free/css/all.css';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

// Add the WhatsApp icon to the library
library.add(faWhatsapp);

// Register the Font Awesome component globally
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

// Register only used Element UI components
Vue.use(Button);
Vue.use(Input);
Vue.use(Dialog);
Vue.use(Image);
Vue.use(Row);
Vue.use(Col);
Vue.use(Card);
Vue.use(Header);
Vue.use(Main);
Vue.use(Container);
Vue.use(Result);
Vue.use(Avatar);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Loading);

Vue.use(bootstrap);

const app = new Vue({
  router,
  render: h => h(App),
  mounted() {
    // Signal the prerenderer that the app has finished rendering.
    // Wait a tick so async route components and the DOM are fully painted.
    this.$nextTick(() => {
      document.dispatchEvent(new Event('render-event'));
    });
  }
});

// Mount only after the initial route (including lazy-loaded components such as
// /thankyou) has resolved, so prerendering captures the fully rendered page.
router.onReady(() => {
  app.$mount('#app');
});
